import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Palette, User, ChevronLeft } from 'lucide-react';
import ColorSettings from '../features/userSettings/components/ColorSettings';
import UserPreferencesSettings from '../features/userSettings/components/UserPreferencesSettings';

const TABS = [
  { id: 'colors', label: 'Colors', icon: Palette },
  { id: 'userPreferences', label: 'User Preferences', icon: User },
];

const AppSettingsPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('colors');

  const renderContent = () => {
    switch (activeTab) {
      case 'colors':
        return <ColorSettings />;
      case 'userPreferences':
        return <UserPreferencesSettings />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white px-6 pt-4 shadow-sm border-b border-gray-200 sticky top-0 z-10">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-1.5 text-secondary hover:text-secondaryDark transition-colors py-1.5 px-3 rounded-md hover:bg-gray-100"
            aria-label="Go back"
          >
            <ChevronLeft size={18} />
          </button>
          <nav className="-mb-px flex space-x-8">
            {TABS.map(({ id, label, icon: Icon }) => (
              <button
                key={id}
                onClick={() => setActiveTab(id)}
                className={`flex items-center gap-2 py-3 px-1 border-b-2 font-medium text-sm transition-colors ${
                  activeTab === id
                    ? 'border-secondary text-secondaryDark'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <Icon className="w-4 h-4" />
                {label}
              </button>
            ))}
          </nav>
        </div>
      </div>

      <div className="p-6">
        {renderContent()}
      </div>
    </div>
  );
};

export default AppSettingsPage;
